var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1917 8.90759C11.3788 8.90759 10.642 9.6133 10.642 10.5746C10.642 11.2292 10.7829 11.5286 10.9077 11.6878C11.0412 11.8581 11.2657 12.0095 11.7078 12.1665L16.959 13.9907C17.5439 14.198 18.1782 14.5087 18.6467 15.1064C19.1243 15.7156 19.3285 16.4906 19.3285 17.4248C19.3285 19.3807 17.7993 21.0453 15.8252 21.0453H12.5564C10.3709 21.0453 8.68848 19.2082 8.68848 17.0341C8.68848 16.4947 9.12578 16.0574 9.66522 16.0574C10.2047 16.0574 10.642 16.4947 10.642 17.0341C10.642 18.22 11.5382 19.0918 12.5564 19.0918H15.8252C16.6381 19.0918 17.375 18.3861 17.375 17.4248C17.375 16.7702 17.2341 16.4707 17.1093 16.3116C16.9758 16.1412 16.7512 15.9899 16.3091 15.8329L11.058 14.0087C10.4731 13.8014 9.83875 13.4906 9.37023 12.893C8.89266 12.2837 8.68848 11.5088 8.68848 10.5746C8.68848 8.61862 10.2176 6.9541 12.1917 6.9541H15.4606C17.6461 6.9541 19.3285 8.79114 19.3285 10.9653C19.3285 11.5047 18.8912 11.942 18.3517 11.942C17.8123 11.942 17.375 11.5047 17.375 10.9653C17.375 9.77939 16.4788 8.90759 15.4606 8.90759H12.1917Z",
    fill: "#040E26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0002 5.20947C14.5396 5.20947 14.9769 5.64678 14.9769 6.18622V21.8141C14.9769 22.3536 14.5396 22.7909 14.0002 22.7909C13.4607 22.7909 13.0234 22.3536 13.0234 21.8141V6.18622C13.0234 5.64678 13.4607 5.20947 14.0002 5.20947Z",
    fill: "#040E26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1.95349C7.3469 1.95349 1.95349 7.3469 1.95349 14C1.95349 20.6531 7.3469 26.0465 14 26.0465C20.6531 26.0465 26.0465 20.6531 26.0465 14C26.0465 7.3469 20.6531 1.95349 14 1.95349ZM0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#040E26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.32d2f5143d629ab79433c6e623a96417.svg";
export { ForwardRef as ReactComponent };